import { useState, useEffect, useRef } from 'react';
import CncAnomalyDetection from './CncAnomalyDetection';
import CncRawData from './CncRawData';
import { backgroundMainColor } from '../Color';
import Toggle from '../Toggle';

function JsMonitoring() {
  const toggleLocalStorageKey = 'jsAutoChangeMonitoring';
  const monitoringArray = [<CncAnomalyDetection />, <CncRawData />];
  const [monitoringIndex, setMonitoringIndex] = useState(0);
  const [autoChangeMonitoring, setAutoChangeMonitoring] = useState(localStorage.getItem(toggleLocalStorageKey) === 'true' || localStorage.getItem(toggleLocalStorageKey) === null);
  const autoChangeMonitoringRef = useRef(autoChangeMonitoring);
  
  useEffect(() => {
    document.title = 'JS MONITORING';

    /*const referrer = document.referrer;
    const domain = referrer.split('https://').join('').split('.sfow2.net')[0];
    if (domain !== 'jstech') {
      setMonitoringIndex(-1);
      window.location.href = 'https://jstech.sfow2.net';
      return;
    }*/

    const intervalId = setInterval(() => {
      if (autoChangeMonitoringRef.current) ChangeMonitoring();
    }, 1000 * 30);

    return () => clearInterval(intervalId);
  },[]);

  function ChangeMonitoring() {
    setMonitoringIndex((previousIndex) => {
      return (previousIndex + 1) % monitoringArray.length
    });
  }

  useEffect(() => {
    autoChangeMonitoringRef.current = autoChangeMonitoring;
  }, [autoChangeMonitoring]);

  const buttonStyle = { 
    backgroundColor: backgroundMainColor, 
    color: 'rgb(204,204,204)', 
    border: 'none', 
    fontSize: 30, 
    width: 39, 
    height: 30, 
    cursor: 'pointer', 
    lineHeight: 1 
  };

  return (
    <>
    {monitoringIndex !== -1 ?
    <div style={{ position: 'relative'}}>
      <button onClick={ChangeMonitoring} style={{ ...buttonStyle, fontSize: 25, lineHeight: 1.3, fontWeight: 'bold', position: 'absolute', top: 22, right: 80 }}>▷</button>
      <div style={{ position: 'absolute', top: 27, right: 140}}>
        <Toggle isToggled={autoChangeMonitoring} setIsToggled={setAutoChangeMonitoring} localStorageKey={toggleLocalStorageKey}/>
      </div>
      {monitoringArray[monitoringIndex]}
    </div>
    : null}
    </>
  );
}

export default JsMonitoring;